import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseBackendUrl } from '../utils/api-utils';
import { createNewEntryFailure, createNewEntrySuccess, getBreakEntriesSuccess, getUpdatedEntries, setEntriesLoading } from "../redux/entrySlice";

export const createNewEntry = createAsyncThunk('entries/createNewBreak', async (arg, {dispatch}) => {
    dispatch(setEntriesLoading())
    try {
        const response = await fetch(`${baseBackendUrl}/entries/new`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + arg.token
            },
            body: JSON.stringify(arg.submitData)
        })
        
        const res = await response.json();
        if (response.ok) {
            dispatch(createNewEntrySuccess());
            arg.navigate(`/app/breaks/${arg.id}`)
        } else {
            throw new Error(res.message)
        }
    } catch (error) {
        console.log(error)
        dispatch(createNewEntryFailure(error.message))
    }
})

export const getBreakEntries = createAsyncThunk('entries/getByBreak', async (arg, {dispatch}) => {
    dispatch(setEntriesLoading())
    try {
        const response = await fetch(`${baseBackendUrl}/entries/${arg.id}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + arg.token
            },
        })
        
        if (response.ok) {
            const entries = await response.json();
            dispatch(getBreakEntriesSuccess(entries))
        }
    } catch (error) {
        console.log(error)
    }
})

export const entryUpdate = createAsyncThunk('entries/updateOne', async (arg, {dispatch}) => {
    dispatch(setEntriesLoading())
    try {
        const response = await fetch(`${baseBackendUrl}/entries/${arg.id}`, {
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + arg.token
            },
            body: JSON.stringify(arg.submitData)
        });
        if (response.ok) {
            const res = await response.json();
            dispatch(getUpdatedEntries(res));
        }
    } catch (error) {
        console.log(error)
    }
})